import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
  postSignup: ['data'],
  setSignupSuccess: ['data'],
  setSignupFailure: ['error']
});

/**
 * Handlers
 */
const STATE = {
  pending: false,
  data: null,
  error: null
}
const INITIAL_STATE = STATE;

// Signup
const insertSignupUser = (state, { data }) => {
  return {...state, pending:true, error:null};
};

const setSignupSuccess = (state, { data }) => {
  return {...state, data, pending:false, error:false};
};

const setSignupFailure = (state, { error }) => {
  return {...state, pending: false, error };
};

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
  [Types.POST_SIGNUP]: insertSignupUser,
  [Types.SET_SIGNUP_SUCCESS]: setSignupSuccess,
  [Types.SET_SIGNUP_FAILURE]: setSignupFailure
});